<template>
  <question
    prevTitle="Back"
    prevEnabled
    nextTitle="Next"
    :nextEnabled="years !== 'Number of years trading'"
    @prevClick="$router.go(-1)"
    @nextClick="next"
  >
    <div class="rounded">
      <h3 v-if="$store.state.clientMode" class="panel inverted">How many years has your company been trading</h3>
      <h3 v-else class="panel inverted">How many years has your client been trading</h3>
      <div class="toplined panel">
        <select v-model="years">
          <option>Number of years trading</option>
          <option>Start-up</option>
          <option>Phoenix</option>
          <option>Up to 1 year</option>
          <option>1 - 3 years</option>
          <option>3+ years</option>
        </select>
      </div>
    </div>
  </question>
</template>
<style lang="scss" scoped>
.panel {
  padding: 1em;
}
</style>
<script>
import question from "@/components/questionTemplate";

export default {
  props: {
    nextRoute: {
      type: String,
      default: "5"
    }
  },
  components: {
    question
  },
  beforeMount: function() {
    this.years = this.$store.state.formData.yearsTrading;
  },
  methods: {
    next: function() {
      if (this.years !== "Number of years trading") {
        this.$store.dispatch("setFormData", {
          yearsTrading: this.years
        });
        this.$router.push(this.nextRoute);
      }
    }
  },
  data: function() {
    return {
      years: "Number of years trading"
    };
  }
};
</script>